import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import ApiCall from "../../utils/Api"
import { toast } from 'react-toastify';
import Web3 from "web3";
import contractABI from '../../utils/contractABI';
import {convertDateFormat,extractTimeFromTimestamp} from "../../utils/services";

export default function SalesTable2({transetionDetails,filterState}) {
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Replace with your contract address
  const TDUcontractAddress=import.meta.env.VITE_APP_TDUcontractAddress
    const [isconnected, setisconnected] = useState(false);
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        setWeb3(web3Instance);
        setisconnected(true);
        localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage
      } catch (error) {
        // if (error?.response?.data?.message) {
        //            toast.error(error.response.data.message);
        //          } else {
        //            toast.error(error.message);
        //          }
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log("Please install MetaMask!");
    }
  };
  useEffect(() => {
    initWeb3();
  }, []);
  useEffect(() => {
    const initContract = async () => {
      try {
        const deployedContract = new web3.eth.Contract(
          contractABI,
          contractAddress
        );
        setContract(deployedContract);

        // localStorage.setItem(
        //   "deployedContract",
        //   JSON.stringify(deployedContract)
        // ); // Save web3 instance to local storage
      } catch (error) {
        console.log(error);
      }
    };

    if (web3) {
      initContract();
    }
  }, [web3]);
  const [ethPrice, setEthPrice] = useState(null);
  const getPriceInUsd=(value)=>{
     const exchangeRate = ethPrice;
             const convertedUsdAmount = parseFloat(value) * exchangeRate;
            return convertedUsdAmount.toFixed(6)
       }
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiCall.Api.get('/thirdPartyApi/getCryptoData');
        const ethereumData = response.data.data['1027'];
        // Extract the USD price from the API response
        const usdPrice = ethereumData.quote.USD.price;
        console.log("🚀 ~ fetchData ~ usdPrice:", usdPrice)
        // Update the state with the USD price

        
        setEthPrice(usdPrice);
        // const exchangeRate = ethereumData.quote.USD.price;
        // const convertedUsdAmount = parseFloat(inputEthValue) * exchangeRate;
        // setUsdAmount(convertedUsdAmount.toFixed(2));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

   function formatEtherFromWei(weiValue, decimalPlaces) {
    // Convert wei to ether using Web3.js utility function
    const etherValue = web3.utils.fromWei(weiValue, "ether");

    // Limit the ether value to a specified number of decimal places
    const formattedEther = parseFloat(etherValue).toFixed(decimalPlaces);

    // Return the formatted ether value with "ETH" appended
    return formattedEther + " ETH";
}
  return (
   <> 
   <span><span style={{fontSize:30,fontWeight:700}}>Unit Name:</span><span style={{fontSize:24,fontWeight:400}}>{transetionDetails[0]?.dataUnit?.name}</span></span>
   <TableContainer style={{borderRadius:9}} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{backgroundColor:"Black"}}>
          <TableRow>
            <TableCell align="center" style={{color:"white"}}>Date & Time Created</TableCell>
            {/* <TableCell align="center" style={{color:"white"}}>Select Period</TableCell> */}
            {/* <TableCell align="center" style={{color:"white"}}>Select Period</TableCell> */}
            <TableCell align="center" style={{color:"white"}}>Transaction ID</TableCell>
            {/* <TableCell align="center" style={{color:"white"}}>From</TableCell> */}
            {/* <TableCell align="center" style={{color:"white"}}>Net Sales in TDU</TableCell> */}
            <TableCell align="center" style={{color:"white"}}>Currency</TableCell>
            <TableCell align="center" style={{color:"white"}}>Value</TableCell>
            <TableCell align="center" style={{color:"white"}}>Net Sales in ETH</TableCell>
            <TableCell align="center" style={{color:"white"}}>View on Block Explorer</TableCell>

            {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
            <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {transetionDetails?.map((row) => (
            <TableRow
              key={row._id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
             <TableCell align="center">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    
                    <span style={{ fontWeight: 600 }}>
                      {" "}
                      {convertDateFormat(row.transactionDate)}
                    </span>
                    <span style={{ color: "gray" }}>
                      {" "}
                      {extractTimeFromTimestamp(row.transactionDate)}
                    </span>
                  </div>
                </div>
              </TableCell>
       
              {/* <TableCell align="center">{row.code}</TableCell> */}
              {/* <TableCell align="center"> {row?.market}</TableCell> */}
              <TableCell align="center"> {row?._id}</TableCell>
              {/* <TableCell align="center"> {row?.WalletAddress}</TableCell> */}
              <TableCell align="center">ETH</TableCell>
              <TableCell align="center" >{getPriceInUsd(web3?.utils?.fromWei(row?.dataUnit.price, "ether"))}</TableCell>
              
              <TableCell align="center" ><div>{formatEtherFromWei(row.providerSplitAmount, 6)}</div> <div>{formatEtherFromWei(row.ownerSplitAmount, 6)}</div> </TableCell>
              <TableCell align="center"><a target='_blank' href={row?.transactionHash}>View On Block Explorer</a></TableCell>

              {/* <TableCell align="center">{row?.timesSold>0 ? (
      <Link to="/detail">View Detail</Link>
    ) : (
      <span style={{ color: 'gray', pointerEvents: 'none' }}>View Detail</span>
    )}</TableCell>  */}

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
}